import { forwardRef } from 'react'
import { ButtonToolbar, Button, Panel, Divider } from 'rsuite'
import cn from 'classnames'
import styles from './styles.module.scss'

export const FormError = ({ children, ...props }) => (
  <div className={styles.customFormError} {...props}>
    {children}
  </div>
)

export const Spinner = (props) => (
  <div className={styles.spinner} {...props} />
)

export const Container = (props) =>
  <div className={styles.layoutContainer} {...props} />

export const ContentContainer = forwardRef(({ className, $rightAlign, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      styles.layoutContent,
      { [styles.layoutContentRight]: $rightAlign },
      className
    )}
    {...props}
  />
))

ContentContainer.displayName = 'ContentContainer'

export const Spacer = (props) =>
  <div className={styles.layoutSpacer} {...props} />

export const Page = (props) => <main className={styles.layoutPage} {...props} />

export const CustomButton = ({ className, ...props }) =>
  <Button className={cn(styles.customFormButton, className)} {...props} />

export const ActionButton = ({ className, $withIcon, ...props }) => (
  <CustomButton
    className={cn(
      styles.customFormButtonAction,
      {
        [styles.customFormButtonWithIcon]: $withIcon
      },
      className
    )}
    {...props}
  />
)

export const PublicationRow = ({ className, ...props }) => (
  <div className={cn(styles.publicationRow, className)} {...props} />
)

export const PublicationButtons = (props) => (
  <div className={styles.publicationButtonGroup} {...props} />
)

export const CustomButtonToolbar = (props) => (
  <ButtonToolbar className={styles.customFormButtonGroup} {...props} />
)

export const Required = (props) => (
  <span className={styles.customFormFieldRequired} {...props} />
)

export const CustomPanel = (props) => (
  <Panel className={styles.layoutPanel} {...props} />
)

export const CustomDivider = (props) => (
  <Divider className={styles.layoutDivider} {...props} />
)

export const FlexColumn = ({ className, gap, alignItems, ...props }) => (
  <div
    className={cn(styles.layoutFlexColumn, className)}
    style={{ ...props.style, gap, alignItems }}
    {...props}
  />
)

export const FlexRow = ({
  className,
  width,
  justifyContent,
  gap,
  ...props
}) => (
  <div
    className={cn(styles.layoutFlexRow, className)}
    style={{ ...props.style, width, justifyContent, gap }}
    {...props}
  />
)
